export default "__VITE_ASSET__ee41b06d__"